import { Icon } from '@/components/Icon';
import { Logo } from '@/components/Logo';
import { Card } from '@/components/ui/card';

/** Production builds fail closed when the OIDC configuration is missing (config.ts). */
export function ConfigError({ missing }: { missing: string[] }) {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-background p-6">
      <Card role="alert" className="w-full max-w-[440px] rounded-xl p-6 shadow-overlay">
        <Logo height={24} />
        <div className="mt-5 flex items-start gap-3">
          <span className="flex size-10 shrink-0 items-center justify-center rounded-lg border border-destructive/30 bg-destructive/10 text-destructive">
            <Icon name="error" size={22} />
          </span>
          <div>
            <h1 className="text-base font-semibold text-foreground">The console is not configured</h1>
            <p className="mt-1 text-[13px] text-muted-foreground">These build-time variables are missing (see apps/console/.env.example):</p>
            <ul className="mt-2 flex flex-col gap-1 font-mono text-xs text-foreground">
              {missing.map((m) => (
                <li key={m}>{m}</li>
              ))}
            </ul>
          </div>
        </div>
      </Card>
    </div>
  );
}
